import React, { Component } from 'react'
import { connect } from 'react-redux'
import { nextStep, previousStep } from '../redux/actions/miscActions'
import { Steps, Divider } from 'antd';
import UploadEmployeeData from './UploadEmployeeData';
import CompanyDetails from './CompanyDetails';
import TaxCalculations from './TaxCalculations';

const { Step } = Steps;

export class TaxForm extends Component {
  handleNextStep=()=>{
    this.props.nextStep()
  }
  handlePrevStep=()=>{
    this.props.previousStep()
  }

  render() {
    const { currentStep } = this.props.misc
    return (
      <div className="steps-form">
        <div className="steps">
        <Steps progressDot current={currentStep} direction="vertical">
        <Step title="Stap 1" description="Tax calculations input" />        
        <Step title="Stap 2" description="Company details" />          
        <Step title="Stap 3" description="Upload employee data" />                  
      </Steps>
        </div>
      <div className="input-fields">
        {currentStep === 0 ? <TaxCalculations/> : null}
        {currentStep === 1 ? <CompanyDetails /> : null}
        {currentStep === 2 ? <UploadEmployeeData /> : null}
      </div>
    
      </div>
    )
  }
}

const mapStateToProps=(state)=>({
  misc: state.misc
})

export default connect(mapStateToProps, {nextStep, previousStep})(TaxForm)
